import React from 'react';
import {ReadPropsBookedAsset} from '../../../../home/helper/request.props.js';
import {PresenterReadBookedAsset} from '../../../../home/presenter.js'
/*import iconMaping from '../../../../utils/IconMaping.js';*/
import BookedAssetRow from './BookedAssetRow.js';

// Modal
import ModalCancelBooking from '../Modal/ModalCancelBooking.js';
import ModalRescheduleDate from '../Modal/ModalRescheduleDate.js';
import ModalDetailMyAsset from '../Modal/ModalDetailMyAsset.js'

import FilterComponent from '../../../../asset/simple_asset/helper/component/FilterComponent.js';
import Pagination from '../../../../component/Pagination.js'
import classnames from 'classnames'
import windowStop from '../../../../utils/windowStop.js';
import lang from 'config/language' 
import PopoverHelper from 'utils/PopoverHelper';

export default class BookedAssetList extends React.Component {
	constructor(props) {
		// console.log('BookedAssetList constructor')
		super(props);

		this.state = {
        RowElement             : '',
        SelectedItem           : null, 
        SelectedItems          : null,
        SelectedItemReschedule : null, 
        ActiveTabNotes         : false,
        modalDetail            : false,
        NextPage               : null,
        modal                  : {CancelBooking: false, RescheduleDate: false},
        Data                   : {count: 0, results: []},
        activeToggle           : {activeIcon : null, activeField : 'Name'},
        // ***Pagination
        table_loading : false,
        current       : 0,
        count         : 0,
        limit         : 0,
		}

		this.loading 			 = true;
    this.tab           = ['alias','name','status', 'site', 'location', 'serial_number']
    this.params_filter = 'fields=&search=';
    this.params_order  = 'ordering=-Asset__Name';
    this.params_page   = 1;

		this.generateRow = this.generateRow.bind(this);
		this.toggleModalCancelBooking  = this.toggleModalCancelBooking.bind(this);
		this.toggleModalRescheduleDate = this.toggleModalRescheduleDate.bind(this);
		this.closeModalRescheduleDate  = this.closeModalRescheduleDate.bind(this);
		
    this.toggleModalDetail = this.toggleModalDetail.bind(this);
    this.closeModalDetail  = this.closeModalDetail.bind(this);
		
    this.activeTabNote = this.activeTabNote.bind(this);
    this.updateRowDate = this.updateRowDate.bind(this); 

    this.onReadSuccess = this.onReadSuccess.bind(this); 
    this.onReadFailed  = this.onReadFailed.bind(this); 
	}

  increment() {
    this.setState({
      count: this.state.count - 1
    })
  }

	updateRow(data){
		const items = this.state.RowElement;
		for (let i = 0 ; i < items.length; i++){
			if (items[i].props.RowData.Alias === data.Alias){
				items.splice(i, 1)
        this.increment()
				break;
			}
		}

		let newState = {
			SelectedItem : null,
			RowElement   : items,
			modal: {
				CancelBooking: !this.state.modal.CancelBooking
			}
		};
		this.setState(newState);
	}

	updateRowDate(data) {
		var items = this.state.RowElement;
		for(let i = 0; i < items.length; i++) {
			if(items[i].props.RowData.Alias === data.Alias) {
				items[i].props.RowData.StartDate = data.StartDate;
				items[i].props.RowData.FinishDate = data.FinishDate;
				items[i] = <BookedAssetRow self={this} RowData={items[i].props.RowData} key={i}></BookedAssetRow>
				break;
			}
		}

		let newState = {
		  RowElement   : items
		};
		this.setState(newState);
	}

	dataWillFilter(filter){
		this.params_filter = filter;
    let page = 1
    this.loadData("Read", filter, this.params_order, page)
	}

	/** Toogle Modal */
	toggleModalCancelBooking(data) {
	  	this.setState({
	  		SelectedItem: data,
	    	modal: {	
	    		CancelBooking: !this.state.modal.CancelBooking
	    	}
	  	});
	}

	toggleModalRescheduleDate(data) {		
	  	this.setState({
	    	SelectedItemReschedule: data,
	    	modal: {
	    		RescheduleDate: !this.state.modal.RescheduleDate
	    }
	  });
	}

	closeModalRescheduleDate() {
		this.setState({
		  	modal: {
		  		RescheduleDate: false
		  }
		});
	}

	toggleModalDetail(asset) {
		// this.loadData('getDetails', this.params_filter, this.params_order, this.params_page, alias)	
		this.setState({
			SelectedItems: asset,
			modalDetail   : true,
		})
	}

	closeModalDetail(){
		this.setState({
			modalDetail: false,
			ActiveTabNotes: false
		})  
	}

	activeTabNote(){
    this.setState({
      ActiveTabNotes: true,
    })
	}

	/* ORDER DATA */
	dataWillOrder(order){
		let parameterOder = 'ordering=' + order;

		if(this.params_order === parameterOder){
			this.params_order = 'ordering=-' + order;
		} else {
			this.params_order = parameterOder;
		}

    this.loadData("Read", this.params_filter, this.params_order, this.params_page)
	}

  /** Generate Row element for table */
	generateRow(row) {
		var element = row.map((val, index) => {
			return (<BookedAssetRow self={this} RowData={val} key={index}></BookedAssetRow>)
		})
		// console.log(element);
		return element;
	}

	loadData(action='Read', filter, order, page, alias='') {
	  PresenterReadBookedAsset(
	    ReadPropsBookedAsset(action, this, this.onReadSuccess, this.onReadFailed, filter, order, page, alias)
	  )
	}

	onReadSuccess(params, response) {
		if(params.action === 'Read') {
		  this.loading = false;
		  this.setState({
		  	RowElement: this.generateRow(response.data.results),
        //Pagination
        table_loading : false,
        current       : response.data.current,
        count         : response.data.count,
        limit         : response.data.limit,
		  })

		}/*else if(params.action=== 'getDetails' ){
			this.setState({
				SelectedItems: response.data.results[0]
			})
		}*/
	}

	onReadFailed(params, response) {
	  // console.log('Read failed')
	}

  handlePageClick = (data) => {
    windowStop()
    let selected = data.selected + 1;
    this.params_page = selected
    
    this.setState({ table_loading: true})

    this.loadData('Read', this.params_filter, this.params_order, this.params_page)
  };

	RenderRowElement() { 
	  if(this.loading) {
	    return (
	      <tr>
	        <td className="table-loading-inside" colSpan="100%">Loading data . . .</td>
	      </tr>
	    )
	  } else if(this.state.RowElement.length > 0) {
	    return (
	      this.state.RowElement
	    )
	  } else {
	    return (
	      <tr>
	        <td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;Booked asset empty</td>
	      </tr>
	    )
	  }
	}

	/*  ============ LifeCyle ============ */
	componentDidMount() {
		this.loadData('Read', this.params_filter, this.params_order, this.params_page);
	}

	componentWillUnmount() {
		windowStop()
	} 

  render() {
    const { current, count, limit, table_loading } = this.state

    return (
    	<div>
	    	<div className="row">
				<div className="col-sm-5 book-a-tool-title">
					<h4 className="card-title mb-0">
						<span><span className="icon-calendar"></span>&nbsp;Booked Assets/ Tools</span>
					</h4>
					<div className="text-muted m-top-8">
						<div className="pull-left spaceRRR cursor-default">
							<span>Total:&nbsp;{this.state.count}</span>&nbsp;Asset
						</div>
					</div>
				</div>
				<div className="col-sm-7">
					<FilterComponent 
            onSearch={(e) => {this.dataWillFilter(e)}} 
            self={this} 
            target={'all'} 
            FBColumn={this.tab}
          />
				</div>
			</div>
			<table className={classnames("table table-responsive table-hover table-outline mb-0 m-top-15", {'loading': table_loading})}>
				<thead className="thead-default">
				  <tr>
				    <th onClick={()=>this.dataWillOrder('Asset__Name')} className="pointer">Booked Asset/Tool</th>
				    <th>User</th>
				    <th onClick={()=>this.dataWillOrder('Asset__SerialNumber')} className="pointer">Serial Number</th>
				    <th onClick={()=>this.dataWillOrder('Site__Name')} className="pointer">Site</th>
				    <th onClick={()=>this.dataWillOrder('Location__Name')} className="pointer">Location</th>
				    <th className="text-center pointer">
				    	<span onClick={()=>this.dataWillOrder('Status')}>
				    		Status
				    	</span>
				    	<PopoverHelper
		            id="booking_assets"
		            placement="bottom"
		            content={lang.booking_assets.status}
		          />
		        </th>
				  </tr>
				</thead>
				<tbody>
					{this.RenderRowElement()}
				</tbody>
			</table>
	  		<div className="row m-top-15">
				<div className="col-md-12 text-center">
					<Pagination
			            current  = {current}
			            count    = {count}
			            limit    = {limit}
			            handle   = {this.handlePageClick}
			            isLoading= {this.state.table_loading}
          />
				</div>
			</div>
			
	    	<ModalDetailMyAsset 
	    		ModalState 		= {this.state.modalDetail}
	    		CloseModal 		= {this.closeModalDetail}
	    		SelectedItems 	= {this.state.SelectedItems}
	    		UserReducer 	= {this.props.UserReducer}
	    	/>

	        <ModalCancelBooking self={this}></ModalCancelBooking>
	        <ModalRescheduleDate self={this}></ModalRescheduleDate>
	    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/BookedAsset/BookedAssetList.js